import React from 'react';
import { FormattedMessage } from 'react-intl';

import { supportUrl } from 'Config/lang';

export const ReviewGuideLines = () =>
  <div className="review-guidelines-container">
    <div className="guideline-title">
      <FormattedMessage id="reviewguidelines.title" defaultMessage="Review Guidelines" />
    </div>

    <div className="guideline-subtitle">
      <FormattedMessage id="reviewguidelines.subtitle" defaultMessage="Please let us know what you like or don’t like about this product and why." />
    </div>

    <div className="points-container">
      <div className="points-column">
        <ul className="guideline-points">
          <li>
            <FormattedMessage id="reviewguidelines.atleastfivecharacters" defaultMessage="At least 30 characters" />
          </li>
          <li>
            <FormattedMessage id="reviewguidelines.focusonthisitem" defaultMessage="Focus on this item rather than our site or service." />
          </li>
        </ul>
      </div>
      <div className="points-column">
        <ul className="guideline-points">
          <li>
            <FormattedMessage id="reviewguidelines.nocompetitorlinks" defaultMessage="No competitor information or links" />
          </li>
          <li>
            <FormattedMessage id="reviewguidelines.keepitclean" defaultMessage="Keep it clean!" />
          </li>
        </ul>
      </div>
    </div>

    <div className="guidence-link-container">
      <FormattedMessage
        id="reviewguidelines.needhelpwritingareview"
        defaultMessage="Need help writing a review? {reviewGuidelines}"
        values={{
          reviewGuidelines: <a className="pl-1 brand-link" href={`${supportUrl()}/articles/4404673772177`} target="_blank" rel="noopener noreferrer">
            <FormattedMessage id="reviewguidelines.reviewguidelineslink" defaultMessage="See our full guidelines." />
          </a>,
        }}
      />
    </div>
  </div>;

export default ReviewGuideLines;
